import './scss/main.scss';

(function($) {
    $('#mobile-menu-toggle').on('click', function(e) {
        $('body').toggleClass('open-menu');
    });
})(jQuery);